/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSimulationDemographyQuery = gql`
  query GetSimulationDemographyQuery {
    getSimulationDemography_simulation_demography {
      demographies {
 id  
college  
employeeCount  
employeeAverageAge  
partnerCount  
childrenCount  
socialSecurities {
 regime  
} 
payrolls {
 code  
amount  
} 
salesArea {
 code  
label  
} 
}
      colleges 
      offerCode 
    }
  }
`;

export default GetSimulationDemographyQuery;
